import { Cafe, TournamentStructure } from "../../../../api/types";
import { getDistanceKm } from "../../../../utils/common";
import { calculateTimes } from "../../../../utils/timer";
import { useCallback } from "react";
import { useRecoilValue } from "recoil";
import { geoCoordState } from "../../../../recoil/geo";
import {
  PremiumStoreInfoWrapper,
  FranchisePubsItemWrapper,
  FranchisePubsItemStatusWrapper,
  FranchisePubInfoWrapper,
  FranchisePubInfoRow,
  FranchisePubLikeWrapper,
  FranchisePubLikeItem,
  FranchiseReservationButton,
  FranchiseLiveWrapper,
} from "../style";
import { useHistory } from "react-router-dom";
interface PremiumStoreItemProps {
  item: Cafe;
  setSelectedStore: (value: Cafe) => void;
  setShowMoreOption: (value: boolean) => void;
}

export const FranchiseItem = ({
  item,
  setSelectedStore,
  setShowMoreOption,
}: PremiumStoreItemProps) => {
  const { latitude, longitude } = useRecoilValue(geoCoordState);
  const history = useHistory();
  const handleMoreOption = useCallback((cafe: Cafe, e: React.MouseEvent) => {
    setSelectedStore(cafe);
    setShowMoreOption(true);
    e.stopPropagation();
  }, []);

  const calcTimerForIsStart = () => {
    for (const pubTournament of item.pubTournamentList) {
      if (pubTournament.timerDto) {
        const time = calculateTimes(
          pubTournament.timerDto,
          pubTournament.structure
        );
        if (time && time.elapsedTimeMs > 0) {
          if (time && time.overStack < 1) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const getStatus = () => {
    const isStart = calcTimerForIsStart();
    if (isStart) return "게임 진행중";
    return "게임 준비중";
  };

  const getRegisterDeadlineOrd = (
    regiLevelOrd: number,
    structure: TournamentStructure[]
  ) => {
    let resultOrd = regiLevelOrd;
    const regiNextLEvel = structure.find((s) => s.ord === resultOrd + 1);
    if (regiNextLEvel && regiNextLEvel.ord && regiNextLEvel.type === "BREAK") {
      resultOrd = regiNextLEvel.ord;
    }
    return resultOrd;
  };

  const getIsReservation = () => {
    if (item.pubTournamentList.length < 1) return false;
    for (const pubTournament of item.pubTournamentList) {
      if (pubTournament.timerDto) {
        const time = calculateTimes(
          pubTournament.timerDto,
          pubTournament.structure
        );

        const regiLevel = pubTournament.structure.find(
          (item) => item.level === pubTournament.registerDeadlineLevel
        );
        if (pubTournament.reservation && regiLevel && regiLevel.ord) {
          const resultOrd = getRegisterDeadlineOrd(
            regiLevel.ord,
            pubTournament.structure
          );
          if (
            (time?.currentLevel.ord && time.currentLevel.ord <= resultOrd) ||
            time?.currentLevel.type === "READY"
          ) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const getLiveText = () => {
    if (!item?.youtubeLiveList) return [];
    const youtubers = item.youtubeLiveList.map((live) => live.name);
    return youtubers;
  };

  return (
    <PremiumStoreInfoWrapper
      onClick={() => {
        history.push(`/store/${item.id}?type=PREMIUM`);
      }}
    >
      <FranchisePubsItemWrapper>
        <img
          alt={item.cafeName}
          src={
            item.images && item.images.length > 0
              ? item.images[0].imageUrl
              : "https://dfesoodpx4jgd.cloudfront.net/cafe/default.png"
          }
        />
        <FranchisePubsItemStatusWrapper isStart={getStatus() === "게임 진행중"}>
          {getStatus()}
        </FranchisePubsItemStatusWrapper>
        <FranchiseReservationButton isActive={getIsReservation()}>
          예약가능
        </FranchiseReservationButton>
        {getLiveText().length > 0 && (
          <FranchiseLiveWrapper>
            <div className="title">LIVE</div>
            <div className="rolling-wrapper">
              <div className="rolling-track">
                <div className="rolling-text">
                  {[...getLiveText(), ...getLiveText()].map((text, i) => (
                    <div key={i}>{text}</div>
                  ))}
                </div>
              </div>
            </div>
          </FranchiseLiveWrapper>
        )}
        <img
          className="more"
          src="/image-web/pub/franchise-more.svg"
          alt="more"
          onClick={(e) => handleMoreOption(item, e)}
        />
      </FranchisePubsItemWrapper>
      <FranchisePubInfoWrapper>
        <FranchisePubInfoRow>
          <div className="pub-name">{item.cafeName}</div>
          <div className="address">
            {item.newAddress} {item.detailAddress}
          </div>
        </FranchisePubInfoRow>
        <FranchisePubLikeWrapper>
          <FranchisePubLikeItem>
            <img src="/image-web/pub/franchise-like.svg" alt="like" />
            <div className="like-count">{item.likeCount}</div>
          </FranchisePubLikeItem>
          <FranchisePubLikeItem>
            <img src="/image-web/pub/franchise-distance.svg" alt="distance" />
            <div className="distance-count">
              {getDistanceKm(latitude, longitude, item.lat, item.lon)}km
            </div>
          </FranchisePubLikeItem>
        </FranchisePubLikeWrapper>
      </FranchisePubInfoWrapper>
    </PremiumStoreInfoWrapper>
  );
};
